import { VehicleLicenseTypeRestrictionsDto } from '../../pages/users/api/dto/get/VehicleLicenseTypeRestrictionsDto'

class VehicleLicenseTypeRestrictions {
  private constructor(age: number, vehicleIds: string[]) {
    this.age = age
    this.vehicleIds = vehicleIds
  }

  private readonly age: number
  private readonly vehicleIds: string[]

  static fromDto(
    vehicleLicenseTypeRestrictionsDto: VehicleLicenseTypeRestrictionsDto,
  ): VehicleLicenseTypeRestrictions {
    return new VehicleLicenseTypeRestrictions(
      vehicleLicenseTypeRestrictionsDto.age,
      vehicleLicenseTypeRestrictionsDto.vehicleId,
    )
  }
}

export default VehicleLicenseTypeRestrictions
